import React from 'react';
import PropTypes from 'prop-types';

const StarEmpty = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.922"
    height="16.201"
    viewBox="0 0 16.922 16.201"
    className={className}
  >
    <path
      d="M4.746,2.014c.425.33.959.234,1.531-.19l3.677-2.7,3.677,2.7c.579.425,1.106.52,1.538.19A1.251,1.251,0,0,0,15.454.5L14-3.816,17.71-6.475c.571-.41.828-.886.652-1.4s-.652-.754-1.355-.747l-4.541.037-1.384-4.343c-.22-.681-.593-1.062-1.128-1.062s-.9.381-1.121,1.062L7.449-8.584,2.9-8.621c-.7-.007-1.179.242-1.348.74-.183.52.073,1,.652,1.406L5.911-3.816,4.46.5A1.251,1.251,0,0,0,4.746,2.014ZM6.5-.4C6.489-.41,6.489-.417,6.5-.454L7.756-3.86c.176-.505.161-.718-.33-1.033L4.417-6.914c-.029-.022-.037-.037-.037-.051s.022-.015.059-.015l3.625.132c.535.015.74-.1.879-.623l.981-3.494c.007-.029.015-.044.029-.044s.029.015.037.044l.981,3.494c.139.52.344.637.886.623l3.618-.132c.037,0,.059,0,.059.015s-.007.029-.029.051L12.48-4.893c-.476.315-.5.527-.322,1.033l1.26,3.406c.007.037.007.044-.007.059s-.022,0-.051-.015L10.51-2.659a.731.731,0,0,0-1.106,0L6.555-.41C6.526-.4,6.511-.381,6.5-.4Z"
      transform="translate(-1.494 13.989)"
      fill={fill}
    />
  </svg>
);

StarEmpty.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default StarEmpty;
